import axiosPost from "./axiosPost";

export const RNESAsignacionDel = async (credentials, data) => {
    const body = {
        service: "RNESAsignacionDel",
        params: {
            rnesAsignacionId: data?.asignacionId,
            rnesAsignacionVersion: data?.version,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
